import { render, staticRenderFns } from "./BasBankAccountList.vue?vue&type=template&id=0a0d6dae&scoped=true&"
import script from "./BasBankAccountList.vue?vue&type=script&lang=js&"
export * from "./BasBankAccountList.vue?vue&type=script&lang=js&"
import style0 from "./BasBankAccountList.vue?vue&type=style&index=0&id=0a0d6dae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0d6dae",
  null
  
)

export default component.exports